import * as types from '../types'

export default (payload) => {
  return {
    type: types.SET_USER,
    payload,
  }
}
